import { useMemo } from 'react';

import { DataRoomContextProvider } from '@/contexts/overview/dataroom/DataRoomContext';
import { OverviewPageLoader } from '@/pages/overview/common/OverviewPageLoader';
import { useOverview } from '@/pages/overview/common/utils';
import NoCompanyOverviewData from '@/pages/overview/company-overview/common/NoCompanyOverviewData';
import { CompanyOverviewContent } from '@/pages/overview/company-overview/content/CompanyOverviewContent';

export type CompanyOverviewData = {
  status: 'processing' | 'success' | 'not_found';
  report: string | null;
  citations: Record<string, string> | null;
  updatedAt?: Date;
};

export const CompanyOverview = () => {
  const { matter } = useOverview();

  const companyOverviewProcessing = useMemo(() => {
    return !matter.finishedProcessingCompanyOverview;
  }, [matter.finishedProcessingCompanyOverview]);

  const companyOverviewData = useMemo(() => {
    return matter.companyOverviewData;
  }, [matter.companyOverviewData]);

  const hasCompanyOverviewData = useMemo(() => {
    return companyOverviewData && companyOverviewData.reportMarkdown;
  }, [companyOverviewData]);

  return (
    <DataRoomContextProvider>
      {companyOverviewProcessing ? (
        <OverviewPageLoader pageFocusTitle="Processing Company Overview Data" />
      ) : hasCompanyOverviewData ? (
        <CompanyOverviewContent
          companyOverviewData={{
            status: 'success',
            report: companyOverviewData?.reportMarkdown ?? null,
            citations: companyOverviewData?.citations as Record<string, string>,
            updatedAt: companyOverviewData?.updatedAt,
          }}
        />
      ) : (
        <NoCompanyOverviewData />
      )}
    </DataRoomContextProvider>
  );
};

export default CompanyOverview;
